import { IsoTimestamp } from '../../../@harmony';

type UserId = string;

export enum ApiKeyStatus {
  Active = 'active',
  Disabled = 'disabled',
}

export interface ApiKeyEntity {
  teamId: string;
  hash: string;
  status: ApiKeyStatus;
  createdAt: IsoTimestamp;
  createdBy: UserId;
  updatedAt: IsoTimestamp;
  lastUsedAt?: IsoTimestamp;
}
